/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Categories } from '../models/categories.interface';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  constructor(private httpClient: HttpClient) {}

  async getCategories(): Promise<Categories[]> {
    return firstValueFrom<Categories[]>(
      this.httpClient.get<Categories[]>(enviroment.url + 'category'),
    );
  }
  async putCategories(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.put<any>(enviroment.url + 'category', element),
    );
  }

  async postCategories(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'category', element),
    );
  }
}
